module.exports = "/_next/static/images/logoDesktopInverted-4ef5c2ca9c8554aecb1057ef5d7e8c53.svg";